export default __webpack_public_path__ + "static/media/nft_up_black.06d63174.svg";